import { WidgetConfig } from '../../../models/widget.config';

export class RadioGroupWidgetConfig extends WidgetConfig<string> {
  widgetType = 'RadioGroupWidget';
  fhirValueSet: string;
  constructor(config: Partial<WidgetConfig<any>>) {
    super(config);
    this.multiple = false;
    this.fhirValueSet = config['fhirValueSet'] || null;
  }
}
